import ApplicationConf from 'conf/ApplicationConf'
import { genericPromise2 } from 'utils/ActionUtils'

const QualitometerAction = {
    getQualitometer: (id, signal) => genericPromise2(ApplicationConf.qualitometer.get(id), { signal }),
}

export default QualitometerAction